import { render, staticRenderFns } from "./GroupRemoveBtn.vue?vue&type=template&id=65cccce1&"
import script from "./GroupRemoveBtn.vue?vue&type=script&lang=js&"
export * from "./GroupRemoveBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports